import React from 'react';
import ReactDOM from 'react-dom';
import * as PIXI from 'pixi.js'

class ToReact extends React.Component {
  componentDidMount() {
    const container = ReactDOM.findDOMNode(this);
    container.appendChild(this.props.data);
  }

  render() {
    return (<div className="ToReact"/>);
  }
}

function keyboard(keyCode) {
  let key = {};
  key.code = keyCode;
  key.isDown = false;
  key.isUp = true;
  key.press = undefined;
  key.release = undefined;
  //The `downHandler`
  key.downHandler = event => {
    if (event.keyCode === key.code) {
      if (key.isUp && key.press) key.press();
      key.isDown = true;
      key.isUp = false;
    }
    event.preventDefault();
  };

  //The `upHandler`
  key.upHandler = event => {
    if (event.keyCode === key.code) {
      if (key.isDown && key.release) key.release();
      key.isDown = false;
      key.isUp = true;
    }
    event.preventDefault();
  };

  //Attach event listeners
  window.addEventListener(
    "keydown", key.downHandler.bind(key), false
  );
  window.addEventListener(
    "keyup", key.upHandler.bind(key), false
  );
  return key;
}

class PixiTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      app: new PIXI.Application({width: 700, height: 700})
    }

    let app = this.state.app;

    let cat, state;

    let loader = new PIXI.Loader("",10)
    loader
    .add("/cat.png")
    .load(setup);
    
    function setup() {
      cat = new PIXI.Sprite(loader.resources["/cat.png"].texture);
      cat.anchor.set(.5, .5);
      cat.x = 350;
      cat.y = 350;
      cat.vx = 0
      cat.vy = 0
      app.stage.addChild(cat);

      let left = keyboard(37),
          up = keyboard(38),
          right = keyboard(39),
          down = keyboard(40);
      const velocity = 5;
      left.press = () => {
        cat.vx = -velocity;
      };
      left.release = () => {
        if (right.isUp) cat.vx = 0;
        else cat.vx = velocity;
      };
      right.press = () => {
        cat.vx = velocity;
      };
      right.release = () => {
        if (left.isUp) cat.vx = 0;
        else cat.vx = -velocity;
      };
      up.press = () => {
        cat.vy = -velocity;
      };
      up.release = () => {
        if (down.isUp) cat.vy = 0;
        else cat.vy = velocity;
      };
      down.press = () => {
        cat.vy = velocity;
      };
      down.release = () => {
        if (up.isUp) cat.vy = 0;
        else cat.vy = -velocity;
      };

      state = play
      app.ticker.add( delta => gameLoop(delta) );
    }
    function gameLoop(delta) {
      state(delta);
    }
    function play(delta) {
      cat.rotation+=delta/10;
      cat.x += cat.vx * delta
      cat.y += cat.vy * delta
    }
  }
  
  render() {
    return (<ToReact data={this.state.app.view}/>);
  }
}

export default PixiTest;